let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gB4Se")).then(() => parcelRequire('55LdR'));